"use client";
import { Button } from "@/components/ui/button";
import { Reveal } from "@/components/reveal";
import Link from "next/link";
import { CtaSectionType } from "./closing";
import { PortableText } from "next-sanity";
import { iconsMap } from "@/components/icons";
import { getURL } from "@/lib/utils";

export function PricingCTA({
  data,
  revealOnLargeScreen = false,
}: {
  data: CtaSectionType;
  revealOnLargeScreen?: boolean;
}) {
  const { heading, subheading, description, buttons } = data;
  return (
    <section className={`block ${revealOnLargeScreen ? "" : "sm:hidden"} bg-primary-50/20 py-10`}>
      <Reveal className="flex items-start lg:items-center lg:justify-between flex-col lg:flex-row max-w-screen-2xl mx-auto px-6 sm:px-24 gap-8">
        <div className="flex flex-col gap-3">
          <h3 className="text-primary-text-700 font-medium text-xl">{heading}</h3>
          {subheading && (
            <h4 className="text-primary-text-500 text-xs lg:text-xl max-w-screen-sm">
              {subheading}
            </h4>
          )}
          {description && (
            <PortableText
              value={description}
              components={{
                block: {
                  normal: ({ children }) => (
                    <p className="text-primary-text-500 text-xs lg:text-xl max-w-screen-sm">
                      {children}
                    </p>
                  ),
                },
              }}
            />
          )}
        </div>
        <div>
          {buttons.map((button, index) => (
            <Button variant={button.variant} radius="full" asChild key={index}>
              <Link href={getURL(button)}
                target={button.openInNewTab ? "_blank" : "_self"}
                rel={button.openInNewTab ? "noopener noreferrer" : undefined}
              >
                {button.textBeforeIcon}
                {button.icon && iconsMap[button.icon]}
                {button.textAfterIcon}
              </Link>
            </Button>
          ))}
        </div>
      </Reveal>
    </section>
  );
}
